/* eslint-disable react/no-array-index-key */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Offcanvas } from 'react-bootstrap';
import {
  FiUpload,
  FiCheckCircle,
  FiLoader,
  FiFile,
  FiInfo,
  FiFileText,
  FiTrash2,
} from 'react-icons/fi';
import AppTextInput from '../../../../shared/components/app-text-input/AppTextInput';
// import { uploadVisaDocumentImageApi } from '../../api/onlineVisaApi';
import './DocumentUpload.scss';
import { uploadImageForRegistrationWithoutS3 } from '../../../../api/agentRegistrationApi';
import { uploadVisaDocumentImageApi } from '../../api/onlineVisaApi';

const ACCEPTED_FORMATS = '.jpg,.jpeg,.png,.pdf';

function DocRow({ doc, index, state, onChange, onOpenDoc, showErrors }) {
  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const docNumberError = showErrors && !state.documentNumber?.trim();
  const docFileError = showErrors && !state.documentUrl;

  const handleChoose = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };

  const handleFile = async (e) => {
    const file = e?.target?.files?.[0];
    if (!file) return;
    const fileExtension = file.name.split('.').pop().toLowerCase();
    const allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf'];
    if (
      !allowedExtensions.includes(fileExtension) ||
      !(file.type.startsWith('image/') || file.type === 'application/pdf')
    ) {
      setError('Only JPG , PNG , PDF files are allowed.');
      e.target.value = '';
      return;
    }
    const maxSize = 10 * 1024 * 1024; // 4MB
    if (file.size > maxSize) {
      setError('The file size should not exceed 10MB.');
      e.target.value = '';
      return;
    }
    setUploading(true);
    setError('');
    try {
      const url = await uploadVisaDocumentImageApi(file);
      if (!url) {
        setError('Upload failed. Please try again.');
        return;
      }
      const ext = (file.name.split('.').pop() || '').toUpperCase();
      onChange(index, {
        ...state,
        documentUrl: url,
        documentFormat: ext || 'JPG',
        fileName: file.name,
      });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('upload failed', err);
      setError('Upload failed. Please try again.');
    } finally {
      setUploading(false);
      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  };

  const handleRemove = () => {
    onChange(index, {
      ...state,
      documentUrl: '',
      documentFormat: '',
      fileName: '',
    });
  };

  return (
    <div className="document-upload__row">
      <div className="document-upload__row-head">
        <div className="document-upload__name">
          <span className="document-upload__name-label">
            <FiFile />
            {doc.documentName}
          </span>
          <button
            type="button"
            className="document-upload__info"
            aria-label={`Info about ${doc.documentName}`}
            title={`Details for ${doc.documentName}`}
            onClick={() => onOpenDoc(doc)}
          >
            <FiInfo />
          </button>
        </div>
      </div>

      <div className="document-upload__row-body">
        {/* <div className="document-upload__number">
          <AppTextInput
            name={`docNumber-${index}`}
            label="Document Number"
            required
            value={state.documentNumber || ''}
            onChange={(e) =>
              onChange(index, {
                ...state,
                documentNumber: e.target.value,
              })
            }
            errorText={docNumberError ? 'Document number required' : ''}
          />
        </div> */}

        <div className="document-upload__file">
          <span className="document-upload__file-label required">
            Click to upload (JPG, PNG, PDF | Max Size: 10 MB)
          </span>
          {!state.documentUrl && (
            <button
              type="button"
              className={`document-upload__drop ${
                docFileError ? 'document-upload__drop--error' : ''
              }`}
              onClick={handleChoose}
              disabled={uploading}
            >
              {uploading ? (
                <>
                  <FiLoader className="document-upload__spin" />
                  <span>Uploading…</span>
                </>
              ) : (
                <>
                  <FiUpload />
                  <span>Click to upload (JPG, PNG, PDF)</span>
                </>
              )}
            </button>
          )}
          {state.documentUrl && (
            <div className="document-upload__preview">
              <FiCheckCircle className="document-upload__preview-ok" />
              <span className="document-upload__preview-name">
                {state.fileName || 'Uploaded'}
              </span>
              <button
                type="button"
                className="document-upload__preview-remove"
                onClick={handleRemove}
                aria-label="Remove file"
              >
                <FiTrash2 />
              </button>
            </div>
          )}
          {docFileError && (
            <small className="document-upload__err">
              Please upload the document image.
            </small>
          )}
          {error && <small className="document-upload__err">{error}</small>}

          <input
            ref={fileInputRef}
            type="file"
            accept={ACCEPTED_FORMATS}
            style={{ display: 'none' }}
            onChange={handleFile}
          />
        </div>
      </div>
    </div>
  );
}

DocRow.propTypes = {
  doc: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onOpenDoc: PropTypes.func.isRequired,
  showErrors: PropTypes.bool.isRequired,
};

function DocumentUpload({
  documents,
  paxLabel,
  docsState,
  onDocsChange,
  showErrors,
}) {
  const [openDoc, setOpenDoc] = useState(null);

  const handleOpen = (doc) => setOpenDoc(doc);
  const handleClose = () => setOpenDoc(null);

  const handleRowChange = (idx, next) => {
    const copy = [...docsState];
    copy[idx] = next;
    onDocsChange(copy);
  };

  if (!documents || documents.length === 0) {
    return (
      <section className="document-upload">
        <header className="document-upload__head">
          <h3 className="document-upload__title">Upload Documents</h3>
          {paxLabel && (
            <span className="document-upload__pax">for {paxLabel}</span>
          )}
        </header>
        <div className="document-upload__empty">
          No documents required. You can proceed to review and pay.
        </div>
      </section>
    );
  }

  return (
    <section className="document-upload">
      <header className="document-upload__head">
        <h3 className="document-upload__title">Upload Documents</h3>
        {paxLabel && (
          <span className="document-upload__pax">for {paxLabel}</span>
        )}
      </header>

      <div className="document-upload__list">
        {documents.map((doc, idx) => (
          <DocRow
            key={`${doc.documentName}-${idx}`}
            doc={doc}
            index={idx}
            state={
              docsState[idx] || {
                documentId: idx + 1,
                documentName: doc.documentName,
                documentNumber: '',
                documentUrl: '',
                documentFormat: '',
                fileName: '',
              }
            }
            onChange={handleRowChange}
            onOpenDoc={handleOpen}
            showErrors={showErrors}
          />
        ))}
      </div>

      <Offcanvas
        show={!!openDoc}
        onHide={handleClose}
        placement="end"
        className="required-documents__offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="required-documents__offcanvas-title">
            <FiFileText />
            <span>{openDoc?.documentName || 'Document details'}</span>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {(() => {
            let content = [];
            if (Array.isArray(openDoc?.content)) {
              content = openDoc.content;
            } else if (openDoc?.documentContent) {
              content = [openDoc.documentContent];
            }
            return content.length > 0 ? (
              <ul className="required-documents__detail-list">
                {content.map((line, idx) => (
                  <li
                    // eslint-disable-next-line react/no-array-index-key
                    key={idx}
                    className="required-documents__detail-item"
                  >
                    <FiCheckCircle />
                    <span>{line}</span>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="required-documents__detail-empty">
                No additional details available for this document.
              </p>
            );
          })()}
          {(openDoc?.url || openDoc?.documentUrl) && (
            <a
              href={openDoc?.url || openDoc?.documentUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="required-documents__detail-link"
            >
              Download sample
            </a>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </section>
  );
}

DocumentUpload.propTypes = {
  documents: PropTypes.array.isRequired,
  paxLabel: PropTypes.string,
  docsState: PropTypes.array.isRequired,
  onDocsChange: PropTypes.func.isRequired,
  showErrors: PropTypes.bool,
};

DocumentUpload.defaultProps = {
  paxLabel: '',
  showErrors: false,
};

export default DocumentUpload;
